"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ projectId }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "プロジェクト名",
                propertyName: "projectName",
                tooltip: "このプロジェクトを表す名前を指定してください",
                schema: {
                    schemaType: "text",
                    required: true,
                },
            },
            {
                title: "詳細説明",
                propertyName: "description",
                schema: {
                    schemaType: "multilineText",
                },
            },
            {
                title: "ロゴ",
                propertyName: "logoUrl",
                tooltip: "このプロジェクトのロゴを登録してください",
                schema: {
                    schemaType: "image",
                    rootPath: projectId ? `projects/${projectId}` : "images",
                    maxHeight: 250,
                },
            },
        ],
    };
};
